import { useTranslation } from "react-i18next";

const RING = {
  success: "border-emerald-400/70 shadow-[0_0_40px_-8px_rgba(52,211,153,0.45)]",
  error: "border-red-400/70 shadow-[0_0_40px_-8px_rgba(248,113,113,0.4)]",
};

// Soft oval viewport: gentle border, no harsh pulsing, easy on the eye.
export const CameraStage = ({ videoRef, phase, error }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-0 flex-1 items-center justify-center py-2">
      <div
        data-testid="camera-stage"
        className={`relative aspect-[68/100] h-full max-h-[min(47dvh,414px)] w-auto max-w-full overflow-hidden rounded-[50%] border bg-muted/40 transition-shadow duration-500 ${
          RING[phase] || "border-border/60 shadow-[0_0_36px_-14px_rgba(0,0,0,0.35)]"
        }`}
      >
        <video ref={videoRef} playsInline muted autoPlay className="h-full w-full -scale-x-100 object-cover" />
        <div className="pointer-events-none absolute inset-0 rounded-[50%] shadow-[inset_0_0_60px_-20px_rgba(0,0,0,0.55)]" />
        {phase === "verifying" ? (
          <div className="absolute inset-x-0 h-px animate-scan-line bg-primary/50" />
        ) : null}
        {error ? (
          <div className="absolute inset-0 flex items-center justify-center bg-background/95 p-4 text-center text-xs font-bold text-red-500">
            {t(`check.${error}`)}
          </div>
        ) : null}
      </div>
    </div>
  );
};
